module.exports = __webpack_public_path__ + "img/tamagoyaki.d8d8af4d.png";